import { Mapper } from "../../../../../harmony/core";
import { ImportSummaryEntity } from "../../data/entities/import-summary.entity";
import { ImportedPartnerEntity } from "../../data/entities/imported-partner.entity";
import { ImportSummary } from "../models/import-summary";
import { ImportCounters } from "../models/import-counters";
import { ImportedPartner } from "../models/imported-partner";
import { PartnersSheetAddress } from "../models/partners-sheet-address";

export class ImportSummaryEntityToImportSummaryMapper
  implements Mapper<ImportSummaryEntity, ImportSummary>
{
  public map(from: ImportSummaryEntity): ImportSummary {
    return new ImportSummary(
      from.partners.map((partner) => this.mapPartner(partner)),
      new ImportCounters(
        from.counters.total,
        from.counters.activated,
        from.counters.prospect,
        from.counters.waitingToBeInvited,
      ),
    );
  }

  private mapPartner(from: ImportedPartnerEntity): ImportedPartner {
    return new ImportedPartner(
      from.partnerId,
      from.companyName,
      from.email,
      new PartnersSheetAddress(
        from.address.streetAndNumber,
        from.address.zipCode,
        from.address.city,
        from.address.country,
      ),
      from.status,
      from.isProspect,
      from.uploadedBy,
    );
  }
}
